import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import { registerHeaderMenu } from './components/header-menu.js';
import { registerCounter } from './components/counter.js';
import { registerCarousel } from './components/carousel.js';
import { registerVideoPlayer } from './components/video-player.js';
import { registerPromoSlider } from './components/promo-slider.js';
import { registerAutocomplete } from './components/autocomplete.js';
import { registerCatalogFilters } from './components/catalog-filters.js';
import { registerSearchAutocomplete } from './components/search-autocomplete.js';
import { registerInfiniteScroll } from './components/infinite-scroll.js';
import { registerProfessionPrompt } from './components/profession-prompt.js';
import { personalizeCatalogLinks } from './utils/catalog-links.js';
import { registerPurchaseSelector } from './components/purchase-selector.js';
import { registerCartStore } from './stores/cart.js';
import { registerCheckoutStore } from './stores/checkout.js';
import { registerWaitingListStore } from './stores/waiting-list.js';
import { registerWishlistStore } from './stores/wishlist.js';
import { registerAuthStore } from './stores/auth.js';
import { registerDashboardStore } from './stores/dashboard.js';
import { registerCartDrawer } from './components/cart-drawer.js';
import { registerAuthDrawer } from './components/auth-drawer.js';
import { registerRegisterDrawer } from './components/register-drawer.js';
import { registerToastManager } from './components/toast-manager.js';
import { registerWishlistManager } from './components/wishlist-manager.js';
import { registerWishlistPage } from './components/wishlist-page.js';
import { registerBundleDeck } from './components/bundle-deck.js';
import { registerArticleCard } from './components/article-card.js';
import { registerBottomNav } from './components/bottom-nav.js';
import { initViewportFix } from './components/viewport-fix.js';
import { initDrawerState } from './components/drawer-state.js';
import { registerDashboardHome } from './components/dashboard-home.js';
import { registerProfileForm } from './components/profile-form.js';
import { registerProfileOccupations } from './components/profile-occupations.js';
import { registerSubscriptionDiscipline } from './components/subscription-discipline.js';
import { registerOrderDetail } from './components/order-detail.js';
import { registerWalletPage } from './components/wallet-page.js';
import { registerCertificatesTimeline } from './components/certificates-timeline.js';
import { registerLessonPlayer } from './components/lesson-player.js';
import { registerQuizPlayer } from './components/quiz-player.js';
import { registerDashboardTest } from './components/dashboard-test.js';
import { registerReferralPromo } from './components/referral-promo.js';
import { registerTestimonialCarousel } from './components/testimonial-carousel.js';
import { registerConsentStore } from './stores/consent.js';
import { initTracking } from './tracking/index.js';
import { registerCookieConsent } from './components/cookie-consent.js';
import { formatCredits } from './utils/format.js';

// Plugin
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Magic globale: formattazione crediti ECM (intero o decimale con virgola)
Alpine.magic('credits', () => formatCredits);

// Consent store (PRIMO — prima di tutti gli altri store)
registerConsentStore(Alpine);

// Store globali (prima dei componenti)
registerCartStore(Alpine);
registerCheckoutStore(Alpine);
registerWaitingListStore(Alpine);
registerWishlistStore(Alpine);
registerAuthStore(Alpine);
registerDashboardStore(Alpine);

// Tracking hooks (dopo gli store, prima dei componenti)
initTracking(Alpine);

// Componenti
registerHeaderMenu(Alpine);
registerCounter(Alpine);
registerCarousel(Alpine);
registerVideoPlayer(Alpine);
registerPromoSlider(Alpine);
registerAutocomplete(Alpine);
registerCatalogFilters(Alpine);
registerSearchAutocomplete(Alpine);
registerInfiniteScroll(Alpine);
registerProfessionPrompt(Alpine);
registerPurchaseSelector(Alpine);
registerCartDrawer(Alpine);
registerAuthDrawer(Alpine);
registerRegisterDrawer(Alpine);
registerToastManager(Alpine);
registerWishlistManager(Alpine);
registerWishlistPage(Alpine);
registerBundleDeck(Alpine);
registerArticleCard(Alpine);
registerBottomNav(Alpine);
registerDashboardHome(Alpine);
registerProfileForm(Alpine);
registerProfileOccupations(Alpine);
registerSubscriptionDiscipline(Alpine);
registerOrderDetail(Alpine);
registerWalletPage(Alpine);
registerCertificatesTimeline(Alpine);
registerLessonPlayer(Alpine);
registerQuizPlayer(Alpine);
registerDashboardTest(Alpine);
registerReferralPromo(Alpine);
registerTestimonialCarousel(Alpine);
registerCookieConsent(Alpine);

// Debug: esponi su window per console
window.Alpine = Alpine;

// Setup globali (post-register, pre-start)
initViewportFix();
personalizeCatalogLinks();

// Start
Alpine.start();

// Effetti reattivi che dipendono dagli store già istanziati (post-start)
initDrawerState(Alpine);
